import { State } from 'reducers';
import { createSelector } from 'reselect';


export const getPath = (state: State) =>
    state.router.location.pathname || ''
;

export const getShellState =
    (state: State) => state.shell;

export const getConfirmationMessage =
    createSelector(getShellState,
        state => state && state.confirm
    );

export const getConfirmationVisible =
    createSelector(getConfirmationMessage,
        message => !!message
    );

export const getLanguage =
    createSelector(getShellState,
        state => state ? state.language : ''
    );

export const getLoginUrl =
    createSelector(getShellState,
        state => state.loginUrl
    );
